import { EmailContactType, PhoneContactType } from "@exonn/js-sdk";
import { ResourceEnum } from "src/constants/constants.ts";
import { useResourceFieldOptions } from "src/system/useResourceFieldOptions.ts";

export const useContactTypes = () => {
  const contactTypes = useResourceFieldOptions({
    resource: ResourceEnum.Contact,
    field: "type",
  });
  const emailTypes = contactTypes.filter((option) =>
    (
      [
        EmailContactType.Standard,
        // EmailContactType.Factura,
        // EmailContactType.Sale,
      ] as string[]
    ).includes(option.value),
  );

  const phoneTypes = contactTypes.filter((option) =>
    (
      [
        PhoneContactType.Landline,
        PhoneContactType.Mobile,
        PhoneContactType.Fax,
      ] as string[]
    ).includes(option.value),
  );

  return {
    emailTypes,
    phoneTypes,
  };
};
